import * as React from 'react'

import { Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import * as styles from './ClearValue.vanilla.css'

type ClearValueProps = {
  onClear: () => void
  text?: string
}

const ClearValue = ({ onClear, text = i18n.t('common.clear_selection') }: ClearValueProps) => {
  return (
    <button className={styles.clear} onClick={onClear}>
      <Text.Normal size="300" weight="medium" color="radicalRed1200">
        {text}
      </Text.Normal>
    </button>
  )
}

export default ClearValue
